export const isEmptyPath = (path: string): boolean => {
  return !path || path === "/";
};
